import { render, staticRenderFns } from "./invoice_detail.vue?vue&type=template&id=86f0ada4"
import script from "./invoice_detail.vue?vue&type=script&lang=js"
export * from "./invoice_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86f0ada4')) {
      api.createRecord('86f0ada4', component.options)
    } else {
      api.reload('86f0ada4', component.options)
    }
    module.hot.accept("./invoice_detail.vue?vue&type=template&id=86f0ada4", function () {
      api.rerender('86f0ada4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_market_activities/components/invoice_detail.vue"
export default component.exports